import { Pipe, PipeTransform } from '@angular/core';

/**
 * Latency in ms → the string the tables show. Anything under 10 s stays in
 * milliseconds with a thousands separator ("1,203 ms"); 10 s and over reads
 * as seconds ("17.1 s"), because five digits of milliseconds sitting next to
 * a three-digit row is hard to compare at a glance. The matching amber colour
 * comes from `.cell-latency--slow` in _admin.scss.
 */
@Pipe({
  name: 'latency',
  standalone: false,
})
export class LatencyPipe implements PipeTransform {
  static readonly SLOW_MS = 10_000;

  transform(ms: number | null | undefined): string {
    const v = ms ?? 0;
    if (v >= LatencyPipe.SLOW_MS) return (v / 1000).toFixed(1) + ' s';
    return v.toLocaleString('en-US') + ' ms';
  }
}
